import React, { FC } from 'react';
import { CircleCloseIcon, GreenTickAnimatedIcon } from 'assets/icons';
import Button, { ButtonType } from 'components/custom-button/CustomButton';
import { getAmountWithCurrency } from 'utils/amountUtils';
import CustomModal from 'components/custom-modal/CustomModal';
import { VoidFn } from 'types/baseTypes';
import { CustomerCard } from 'containers/customers/customers.model';
import { getCardIcon, getCardType } from 'containers/receipts/util';

interface ChargeCardOnFileSuccessProps {
  amount: number;
  cardData: CustomerCard;
  transactionId: string;
  onSendInvoice: VoidFn;
  onClose: VoidFn;
}

const ChargeCardOnFileSuccess: FC<ChargeCardOnFileSuccessProps> = ({
  amount,
  cardData,
  transactionId,
  onSendInvoice,
  onClose
}) => {
  return (
    <CustomModal
      open={true}
      closeModal={onClose}
      className="flex flex-col"
      width="w-full lg:w-[375px]"
      height="min-h-screen lg:min-h-0"
      borderRadius="rounded-none lg:rounded-lg">
      {/* Header */}
      <div className="flex w-full justify-end p-4">
        <button onClick={onClose} className="flex h-6 w-6 items-center justify-center" aria-label="Close">
          <CircleCloseIcon className="shrink-0 cursor-pointer" />
        </button>
      </div>

      {/* Content */}
      <div className="flex flex-1 flex-col px-[30px]">
        {/* Success Message and Details */}
        <div className="flex flex-col items-center">
          <GreenTickAnimatedIcon className="h-[76px] w-[76px] shrink-0" />
          <div className="my-5 text-17px font-semibold text-successHighlight">Payment Success!</div>
          <div className="text-4xl font-bold text-primaryText">{getAmountWithCurrency(amount)}</div>

          {/* Divider */}
          <div className="my-8 w-full border-b border-borderGray" />

          {/* Card Details */}
          {cardData && (
            <>
              <div className="flex items-center gap-1">
                <img src={getCardIcon(cardData.network)} alt="" className="h-5 w-5" />
                <span className="text-sbase font-semibold text-tertiaryText">
                  {getCardType(cardData.network)} {cardData.cardLast4}
                </span>
              </div>

              <div className="mt-2 text-px13 font-semibold text-tertiaryText">(Card on file)</div>
            </>
          )}

          {/* Transaction ID */}
          <div className="mt-8 text-px13 text-primaryText">#{transactionId}</div>
        </div>

        {/* Action Buttons */}
        <div className="mt-auto flex flex-col gap-6 pb-9 pt-[60px]">
          <div className="text-center text-xl font-bold text-primaryText">Send Invoice to Customer?</div>
          <Button id="charge-card-send-invoice-confirm-btn" onClick={onSendInvoice} className="h-12 w-full">
            Yes
          </Button>
          <Button
            id="charge-card-send-invoice-cancel-btn"
            onClick={onClose}
            type={ButtonType.SECONDARY}
            className="h-12 w-full">
            No
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default ChargeCardOnFileSuccess;
